import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import Details from "../components/Confirm/Details";
import Button from "../components/Button";
import Box from "../components/Confirm/Box";

import { getRates, runKyc } from "../actions/buy";

const Confirm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { ltc_amount, rates } = useSelector((state) => state.buy);
  let { valid_until } = rates;

  useEffect(() => {
    dispatch(getRates(Number(ltc_amount)));

    const refreshRates = setInterval(() => {
      let time = new Date();
      let validTime = new Date(valid_until);
      if (time.getTime() >= validTime) {
        dispatch(getRates(Number(ltc_amount)));
      }
    }, 2000);

    return () => {
      clearInterval(refreshRates);
    };
  }, []);

  const handleClick = async () => {
    dispatch(await runKyc());
    navigate("/submit");
  };

  return (
    <div>
      <H1>Review & Confirm</H1>
      <Box />
      <Div>
        <Card>
          <Details />
        </Card>
      </Div>
      <Button
        disabled={false}
        title="Buy Litecoin"
        onClick={() => handleClick()}
      />
    </div>
  );
};

const H1 = styled.h1`
  font-size: 18px;
  color: #333333;
  padding-top: 30px;
  padding-left: 30px;
`;

const Card = styled.div`
  width: 320px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.12);
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 100px;
`;

export default Confirm;
